var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 5.83333V5C14.1667 3.61929 13.0474 2.5 11.6667 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V11.6667C2.5 13.0474 3.61929 14.1667 5 14.1667H5.83333V15C5.83333 16.3807 6.95262 17.5 8.33333 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V8.33333C17.5 6.95262 16.3807 5.83333 15 5.83333H14.1667ZM11.6667 3.33333H5C4.07953 3.33333 3.33333 4.07953 3.33333 5V11.6667C3.33333 12.5871 4.07953 13.3333 5 13.3333H5.83333V8.33333C5.83333 6.95262 6.95262 5.83333 8.33333 5.83333H13.3333V5C13.3333 4.07953 12.5871 3.33333 11.6667 3.33333ZM6.66667 8.33333C6.66667 7.41286 7.41286 6.66667 8.33333 6.66667H15C15.9205 6.66667 16.6667 7.41286 16.6667 8.33333V15C16.6667 15.9205 15.9205 16.6667 15 16.6667H8.33333C7.41286 16.6667 6.66667 15.9205 6.66667 15V8.33333Z",
    fill: "#2D3436",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.96ac146e9658fd21b831aa3db54c36d6.svg";
export { ForwardRef as ReactComponent };